/* eslint-disable */
import * as Yup from 'yup';
import { useState, useEffect } from 'react';
import { Container, Card } from '@material-ui/core';
import { useFormik, Form, FormikProvider } from 'formik';
import { Stack, TextField, InputAdornment, IconButton, Radio, Button, Box } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import Page from '../../../Page';
import services from '../Service';
import TokenDecoder from 'src/helpers/TokenDecoder';
import _ from 'lodash';
import permissionAuth from 'src/utils/permissionAuth';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';
import Paper from '@material-ui/core/Paper';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import { makeStyles } from '@material-ui/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Checkbox from '@material-ui/core/Checkbox';
import QRCode from 'react-qr-code';
import CreatePDF from './CreatePDF';
import ReactToPrint from "react-to-print";
import { useRef } from 'react';

var screenCode = 'PRINTQRTAG';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%'
  },
  paper: {
    width: '100%',
    marginBottom: theme.spacing(2)
  },
  table: {
    minWidth: 750
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1
  }
}));

export default function QRCodePrint(props) {
  const classes = useStyles();
  const componentRef = useRef();
  const [group, setGroup] = useState([]);
  const [factory, setFactory] = useState([]);
  const [QRTagsDetails, setQRTagsDetails] = useState([]);
  const [QRTagsDetails1, setQRTagsDetails1] = useState([]);
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const [saveData, setSaveData] = useState([]);
  const [checkAll, setCheckAll] = useState(false);
  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false
  });

  const [formData, setFormData] = useState({
    groupID: '0',
    operationEntityID: '0',
    isActive: false
  });
  const productcatogerySearchSchema = Yup.object().shape({
    groupID: Yup.number().min(1, 'Please Select Group').required('Group Required'),
    operationEntityID: Yup.number()
      .min(1, 'Please Select Fresh Distribution Center')
      .required('Fresh Distribution Center is Required'),
    noOfCodes: Yup.string().required('No Of Codes Required')
  });

  const selectAll = () => {
    setCheckAll(!checkAll);
  };

  const formik = useFormik({
    initialValues: {
      groupID: formData.groupID,
      operationEntityID: formData.operationEntityID,
      isActive: formData.isActive
    },
    validationSchema: productcatogerySearchSchema,
    onSubmit: (values) => { }
  });

  useEffect(() => {
    getPermissions();
  }, []);

  async function getPermissions() {
    var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find((p) => p.permissionCode == 'QRCODEPRINT');

    if (isAuthorized === undefined) {
      navigate('/404');
    }

    var isGroupFilterEnabled = permissions.find((p) => p.permissionCode == 'GROUPDROPDOWN');
    var isFactoryFilterEnabled = permissions.find((p) => p.permissionCode == 'FACTORYDROPDOWN');

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined
    });

    setValues({
      ...values,
      groupID: parseInt(TokenDecoder.getGroupFactoryToken().group),
      operationEntityID: parseInt(TokenDecoder.getGroupFactoryToken().factory)
    });
    trackPromise(GetAllGroups());
  }

  const { setValues, touched, handleSubmit, isSubmitting, getFieldProps, values } = formik;

  useEffect(() => {
    trackPromise(GetAllGroups());
  }, []);

  useEffect(() => {
    trackPromise(GetFactoriesByGroupID());
  }, [formik.values.groupID]);

  useEffect(() => {
    if (formik.values.operationEntityID != 0) {
      trackPromise(handleSearch());
    }
  }, [formik.values.operationEntityID]);

  async function GetAllGroups() {
    var res = await services.GetAllGroups();
    if (res != null) {
      setGroup(res);
    }
  }

  async function GetFactoriesByGroupID() {
    var res = await services.GetFactoriesByGroupID(formik.values.groupID);
    if (res != null) {
      setFactory(res);
    }
  }
  async function handleSearch() {
    const response = await services.GetQRTagForQRCode(
      formik.values.groupID,
      formik.values.operationEntityID
    );
    setQRTagsDetails(response);
  }

  function handleClick(data) {
    let collectionTagData = {
      collectionTagID: data.collectionTagID,
      tagNo: data.tagNo
    };

    let dataRecords = [...saveData];

    var isEnable = dataRecords.find((p) => p.collectionTagID == data.collectionTagID);
    if (isEnable === undefined) {
      dataRecords.push(collectionTagData);
    } else {
      var index = dataRecords.indexOf(isEnable);
      dataRecords.splice(index, 1);
    }
    setSaveData(dataRecords);
  }

  function handleClickAll(e) {
    var tagDataCopy = [...saveData];
    if (e.target.checked) {

      QRTagsDetails.forEach((x) => {
        let collectionTagData = {
          collectionTagID: x.collectionTagID,
          tagNo: x.tagNo
        };

        var isEnable = tagDataCopy.find((p) => p.collectionTagID == x.collectionTagID);
        if (isEnable === undefined) {
          tagDataCopy.push(collectionTagData);
        }
      });
      setSaveData(tagDataCopy);
    } else {
      setSaveData([]);
    }
  }

  async function handleTrigger(e) {
    const response = await services.updateStatus(saveData);
    if ((response.statusCode = true)) {
      toast.success('QR Tags Printed Successfully');
      setSaveData([]);
    }
    else {
      toast.error('Error Occured When QR Code Printing');
    }
    setTimeout(() => {
      handleSearch();
    }, 3000);
  }

  function checkData(row) {
    let sd = (!(saveData.find((x) => x.collectionTagID === row.collectionTagID) == undefined))
    return sd;
  }

  return (
    <>
      <LoadingComponent />
      <Page title="QR Code Print |  FAPS">
        <Container>
          <CommonPageHeader
            btname="Add"
            pageName="QR Code Print"
            leftButtonHidden={true}
          />
          <FormikProvider value={formik}>
            <ToastContainer position="bottom-right" pauseOnHover />
            <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
              <Stack spacing={2}>
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                  <TextField
                    select
                    fullWidth
                    size="small"
                    label="Group *"
                    value={formik.values.groupID}
                    onChange={formik.handleChange}
                    {...getFieldProps('groupID')}
                    error={Boolean(touched.groupID && errors.groupID)}
                    helperText={touched.groupID && errors.groupID}
                    InputProps={{
                      readOnly: !permissionList.isGroupFilterEnabled
                    }}
                  >
                    <MenuItem key={0} value={0}>
                      {' '}
                      Select Group
                    </MenuItem>
                    {group.map((option) =>
                      option.isActive == true ? (
                        <MenuItem key={option.groupID} value={option.groupID}>
                          {option.groupName}
                        </MenuItem>
                      ) : null
                    )}
                  </TextField>
                  <TextField
                    select
                    fullWidth
                    size="small"
                    label="Fresh Collection Center *"
                    value={formik.values.operationEntityID}
                    onChange={formik.operationEntityID}
                    {...getFieldProps('operationEntityID')}
                    error={Boolean(touched.operationEntityID && errors.operationEntityID)}
                    helperText={touched.operationEntityID && errors.operationEntityID}
                    InputProps={{
                      readOnly: !permissionList.isFactoryFilterEnabled
                    }}
                  >
                    <MenuItem key={0} value={0}>
                      {' '}
                      Select Fresh Distribution Center
                    </MenuItem>
                    {factory.map((option) =>
                      option.isActive == true && option.factoryType == 2 ? (
                        <MenuItem key={option.factoryID} value={option.factoryID}>
                          {option.factoryName}
                        </MenuItem>
                      ) : null
                    )}
                  </TextField>
                </Stack>
                <Stack>
                  <FormControlLabel
                    control={
                      <Switch
                        value={formik.values.isActive}
                        checked={formik.values.isActive}
                        {...getFieldProps('isActive')}
                        onClick={formik.handleChange}
                        color="error"
                        name="isActive"
                        inputProps={{ 'aria-label': 'primary checkbox' }}
                      />
                    }
                    label="QR Tag Display"
                  />
                </Stack>
                <br />
              </Stack>
            </Form>
          </FormikProvider>
          {QRTagsDetails.length > 0 ? (
            <Card style={{ justifycontent: 'center', width: 'auto' }}>
              <TableContainer component={Paper}>
                <Table aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell align="center">
                        <Checkbox
                          color="secondary"
                          onClick={(e) => handleClickAll(e)}
                          onChange={selectAll}
                          checked={
                            QRTagsDetails.length != 0 && saveData.length == QRTagsDetails.length
                          }
                        ></Checkbox>
                        Select All
                      </TableCell>
                      <TableCell align="left">Tag No</TableCell>
                      <TableCell align="left">QR Code</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {QRTagsDetails.map((row) => (
                      <TableRow key={row.collectionTagID}>
                        <TableCell align="center">
                          <Checkbox
                            color="secondary"
                            checked={checkData(row)}
                            onChange={() => handleClick(row)}
                            inputProps={{ 'aria-label': 'primary checkbox' }}
                          />
                        </TableCell>
                        <TableCell align="left">{row.tagNo}</TableCell>
                        <TableCell align="left">
                          <QRCode value={row.tagNo} size={56} />
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Card>
          ) : null}
          {QRTagsDetails.length > 0 ?
            <Box display="flex" justifyContent="flex-end" p={2}>
              <ReactToPrint
                documentTitle={"Cargills QR codes"}
                trigger={() => <Button
                  color="secondary"
                  id="btnRecord"
                  type="submit"
                  variant="contained"
                  style={{ marginRight: '1rem' }}
                  className={classes.colorCancel}
                  disabled={saveData.length != 0 ? false : true}
                >
                  PDF
                </Button>}
                onAfterPrint={(e) => handleTrigger(e)}
                content={() => componentRef.current}
              />
              <div hidden={true}>
                <CreatePDF ref={componentRef}
                  qRTagsDetailsList={saveData}
                  isPrint={formData}
                />
              </div>
            </Box> : null}
        </Container>
      </Page>
    </>
  );
}
